export class Vessel {
    id = null;
}
